import { render } from "./IncomeSelect.vue?vue&type=template&id=fc98ee0c&scoped=true"
import script from "./IncomeSelect.vue?vue&type=script&lang=js"
export * from "./IncomeSelect.vue?vue&type=script&lang=js"

import "./IncomeSelect.vue?vue&type=style&index=0&id=fc98ee0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc98ee0c"]])

export default __exports__